import { LOADING_STATE } from "types/general";
import { IState } from "./types";

export const DEMOGRAPHICS_SLICE_NAME = "demographics";

export const initialState: IState = {
  loadingState: LOADING_STATE.idle,
};
